import { render } from "./SignupStepSelectNewsletters.vue?vue&type=template&id=a604a7de"
import script from "./SignupStepSelectNewsletters.vue?vue&type=script&lang=js"
export * from "./SignupStepSelectNewsletters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__